var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4288 12.4288L17 17M7.54542 1C6.25086 1 4.98537 1.38388 3.90898 2.1031C2.83259 2.82232 1.99365 3.84458 1.49824 5.04059C1.00284 6.23661 0.873215 7.55268 1.12577 8.82236C1.37833 10.0921 2.00172 11.2583 2.91711 12.1737C3.8325 13.0891 4.99879 13.7125 6.26847 13.9651C7.53816 14.2176 8.85422 14.088 10.0502 13.5926C11.2463 13.0972 12.2685 12.2582 12.9877 11.1819C13.707 10.1055 14.0908 8.83998 14.0908 7.54542C14.0907 5.8095 13.4011 4.14471 12.1736 2.91723C10.9461 1.68975 9.28134 1.00011 7.54542 1Z",
    stroke: "#505762",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.139dbd9618ea411c5ab6d3dcab7388e0.svg";
export { ForwardRef as ReactComponent };